import { ErrorMessage, Field, Form, Formik } from "formik";
import { Modal } from "react-bootstrap";
import axiosClient from "../../../../../utils/api/axiosClient";
import { getToken } from "../../../../../utils/functions";
import { ProfessionSchema } from "../validation";

export default function FormModel(props: any) {
  const { setProfessions, initial, setInitial, modalShow, setModalShow } =
    props;

  const handleSubmit = (values: { name: string; status: boolean }) => {
    const headers = { Authorization: getToken() };
    // create
    const formData = {
      name: values.name,
      status: values.status,
    };
    if (initial.id) {
      axiosClient
        .put("v1/professions/" + initial.id, formData, { headers })
        .then((res) => {
          if (res.status === 200) setProfessions(res.data);
        });
    } else {
      axiosClient.post("v1/professions", formData, { headers }).then((res) => {
        if (res.status === 200) setProfessions(res.data);
      });
    }
    values.name = "";
    values.status = false;
    setInitial({ id: 0, name: "", status: false });
  };

  return (
    <Modal
      show={modalShow}
      onHide={() => setModalShow(false)}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Edit Profession
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Formik
          initialValues={initial}
          validationSchema={ProfessionSchema}
          onSubmit={handleSubmit}
        >
          {({ touched, errors, handleChange, values }) => (
            <Form className="auth-form login-form">
              <div className="email mb-3">
                <label htmlFor="name">Profession Name</label>
                <Field
                  id="name"
                  name="name"
                  values={initial.name}
                  placeholder="Enter Name"
                  autoComplete="off"
                  className={`mt-2 form-control ${
                    touched.name && errors.name ? "is-invalid" : ""
                  }`}
                />

                <ErrorMessage
                  component="div"
                  name="name"
                  className="invalid-feedback"
                />
              </div>
              <div className="extra mt-3 row justify-content-between">
                <div className="col-6">
                  <div className="form-check">
                    <label className="form-check-label" htmlFor="status">
                      Is active ?
                    </label>
                    <input
                      id="status"
                      name="status"
                      className="form-check-input"
                      type="checkbox"
                      onChange={handleChange}
                      defaultChecked={values.status}
                    />
                  </div>
                </div>
              </div>
              <div className="text-center">
                <button
                  type="submit"
                  className="btn app-btn-primary w-100 theme-btn mx-auto"
                >
                  SAVE
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
}
